import { Form, Spacer, Body, colors, TooltipIcon } from '@spritz-finance/ui'
import { useFormContext } from 'react-hook-form'
import { Row } from '../../../../../components/Layout/Row'
import { useScreenSize } from '../../../../../context/useScreenSize'
import { cssVar } from '../../../../../theme/utils'
import { useCreateSubscription } from './create/CreateSubscriptionProvider'
import { SubscriptionData } from './SubscriptionForm'
import { getOrdinal } from './utils'

export const PaymentDateSelect = () => {
    const { container } = useCreateSubscription()
    const { isMobile } = useScreenSize()
    const { watch } = useFormContext<SubscriptionData>()
    const dayVal = watch('day')
    const day = Number(dayVal)

    const showDetails = day > 28
    return (
        <>
            <Row>
                <Spacer width={16} />
                <Body.Med size={12} secondary>
                    Payment date
                </Body.Med>
                <TooltipIcon
                    size={24}
                    side="top"
                    controlled={isMobile}
                    text="Plan ahead! Payments may take up to 4 business days to reach your account."
                    boundary={container}
                />
            </Row>
            <Spacer height={8} />
            <Row style={{ alignItems: 'center' }}>
                <div style={{ width: '127px', height: '48px' }}>
                    <Form.Select
                        name="day"
                        options={Array.from({ length: 31 }, (_, i) => i + 1)}
                        renderLabel={(o) => `${o}${getOrdinal(o)}`}
                    />
                </div>
                <Spacer width={8} />
                <Body.Med size={16}>of every month for</Body.Med>
                <Spacer width={8} />
                <div style={{ width: '129px', height: '48px' }}>
                    <Form.Select
                        name="totalPayments"
                        // hack because the select wont render 0 for some reason
                        options={Array.from({ length: 25 }, (_, i) => i + 1)}
                        renderLabel={(o) => {
                            if (o === 1) return 'unlimited'
                            return `${o - 1}`
                        }}
                    />
                </div>
                <Spacer width={16} />
                <Body.Med size={16}>months</Body.Med>
            </Row>
            {showDetails && (
                <>
                    <Spacer height={8} />
                    <Row>
                        <Body.Med
                            size={16}
                            color={cssVar('--text-tertiery', colors.medGrey)}
                            style={{ fontStyle: 'italic', maxWidth: 500 }}
                        >
                            {`In months with less than ${day} days, the payment will be processed on the
                            last day of that month.`}
                        </Body.Med>
                    </Row>
                </>
            )}
        </>
    )
}
